export default function text(message) {
  return message.body.name;
}
